import request from "@/utils/request";
export default {
  // 分页查询Farmgroup列表
  getFarmGroup: (param) => {
    return request({
      url: `/rmc/produce/farmGroup/list`,
      method: "post",
      data: param,
    });
  },
  // 启用Farmgroup列表
  farmActive: (param) => {
    return request({
      url: `/rmc/produce/farmGroup/active`,
      method: "post",
      data: param,
    });
  },
  // 禁用Farmgroup列表
  farmInactive: (param) => {
    return request({
      url: `/rmc/produce/farmGroup/inactive`,
      method: "post",
      data: param,
    });
  },
  // 删除Farmgroup列表
  deleteFarm: (param) => {
    return request({
      url: `/rmc/produce/farmGroup/delete`,
      method: "post",
      data: param,
    });
  },
  // 提交Farmgroup列表
  submitFarm: (param,id) => {
    return request({
      url: `/rmc/produce/farmGroup/submit/${id}`,
      method: "post",
      data: param,
    });
  },
  // 更新保存Farmgroup列表
  updateFarm: (param,id) => {
    return request({
      url: `/rmc/produce/farmGroup/update/${id}`,
      method: "post",
      data: param,
    });
  },
  // 添加Farmgroup列表
  addFarm: (param,id) => {
    return request({
      url: `/rmc/produce/farmGroup/create`,
      method: "post",
      data: param,
    });
  },
  // farm Group查询
  farmGroupList: (param,id) => {
    return request({
      url: `/rmc/produce/farmGroup/farmGroupList?sponsor=${id}`,
      method: "post",
      data: param,
    });
  },
  // farm Group详情
  farmGroupDetail: (param,id) => {
    return request({
      url: `/rmc/produce/farmGroup/detail/${id}`,
      method: "post",
      data: param,
    });
  },
  // 生成待办任务
  generateTodoList: (param) => {
    return request({
        url: `/rmc/produce/farmGroup/generateTodoList`,
        method: 'post',
        data: param
    });
},
  // 删除待办任务
  deleteTodoList: (param) => {
      return request({
          url: `/rmc/produce/farmGroup/deleteTodoList`,
          method: 'post',
          data: param
      });
  },
  // 关联数据列表
  getRmcReferenceList: (param) => {
    return request({
        url: `/rmc/produce/farmGroup/rmcReferenceList/${param}`,
        method: 'post',
    });
  },
  // 导出
  downFarmGroup: (param) => {
    return request({
        url: `/rmc/produce/farmGroup/downFarmGroup`,
        method: 'post',
        data:param,
        responseType: "blob",
        fullResponse: true,
    });
  },
  // farm操作日志
  getFarmaActionListt: (param) => {
    return request({
        url: `/rmc/produce/farmGroup/actionList `,
        method: 'post',
        data:param
    });
  },
  
};
